class CsrfStorage {
  private csrfToken: string | null = null;

  getToken() {
    return this.csrfToken;
  }

  setToken(token: string | null) {
    this.csrfToken = token;
  }
}

export const csrfStorage = new CsrfStorage();
